<template>
  <div class="mentIndex">
    <div class="home_con">
      <div class="moment"><Menthu /></div>

      <div class="mentCon">
        <div class="ment_title">总则</div>
        <p>1.范围</p>
        <span>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分规定了电动汽车充换电服务信息交换的总体要求，包括充换电服务信息交换体系结构、信息交换服务流程、信息交换功能、安全机制以及性能指标要求。<br />
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;本部分适用于归属不同运营商的电动汽车充换电运营服务平台之间的充换电服务信息交换，以及电动汽车充换电运营服务平台与第三方服务及管理平台之间的信息交换。</span
        >
        <p>2.规范性引用文件</p>
        <span
          >下列文件对于本文件的应用是必不可少的。凡是注日期的引用文件，仅注日期的版本适用于本文件。凡是不注日期的引用文件，其最新版本（包括所有的修改单）适用于本文件。<br />
          GB/T 19596-2004 电动汽车术语<br />
          GB/T 29317-2012 电动汽车充换电设施术语<br />
          GB/T 27930-2015
          电动汽车非车载传导式充电机与电池管理系统之间的通信协议<br />
          GB/T 28569-2012 电动汽车交流充电桩电能计量<br />
          GB/T 29318-2012 电动汽车非车载充电机电能计量<br />
          GB/T 25070-2010 信息安全技术信息系统等级保护安全设计技术要求 <br />
          GB/T 20271-2006 信息安全技术信息系统安全通用技术要求 </span
        >

        <p>3.术语和定义</p>
        <span
          >GB/T 19596、GB/T 29317、GB/Z
          19027-2005中确立的以及下列术语和定义适用于本文件。</span
        >

        <p>3.1</p>
        <span
          >电动汽车使用者  EV Driver<br />
          通过电动汽车基础设施进行能量补充服务的用户。</span
        >
        <p>3.2</p>
        <span
          >电动汽车充换电服务  EV charging service <br />
          运营商提供电动汽车使用者的，包括通过身份识别认证，充换电，支付结算的整个过程。</span
        >
        <p>3.3</p>
        <span
          >电动汽车充换电服务运营商  EV charging and battery swap service
          operator<br />
          为电动汽车用户提供充换电服务的提供者。简称运营商。</span
        >
        <p>3.4</p>
        <span
          >电动汽车充换电服务平台  EV charging and battery swap service
          platform<br />
           对电动汽车信息及电动汽车基础设施信息进行采集、处理和运行管理，向用户提供充换电服务、业务管理及信息服务功能的支撑系统，简称服务平台。</span
        >
        <p>3.5</p>
        <span
          >电动汽车充换电服务公共信息 EV charging and battery swap service
          common information<br />
          电动汽车充换电服务中涉及的通用信息，包括电动汽车充换电服务资源信息、电动汽车充换电服务统计信息。</span
        >
        <p>3.6</p>
        <span
          >电动汽车充换电服务资源信息 EV charging and battery swap service
          directory information<br />
          电动汽车充换电服务中涉及的基本信息目录，包括设备标识，名称，位置，坐标，服务公示信息以及状态等。</span
        >
        <p>3.7</p>
        <span
          >电动汽车充换电服务统计信息 EV charging and battery swap service
          statistics information<br /> 
          电动汽车充换电服务平台之间信息交换的统计类数据，例如累计电量，累计时长等。</span
        >
        <p>3.8</p>
        <span
          >电动汽车充换电服务业务信息 EV charging and battery swap service
          business information<br />
          电动汽车充换电服务平台之间实现充换电业务漫游等功能所需的业务流程信息，完成认证、充电启动、充电停止以及订单信息与结算。</span
        >
        <p>3.9</p>
        <span
          >电动汽车充换电业务漫游 EV charging and battery swap service
          roaming<br />
           一个运营商向另一个运营商的注册用户提供充换电服务的过程。</span
        >
        <p>3.10</p>
        <span
          >基础设施运营商 EVI service operator<br />
          提供电动汽车充电基础设施服务的运营商。</span
        >
        <p>3.11</p>
        <span
          >客户归属运营商 Service operator for ev driver <br />
          电动汽车使用者注册入网的运营商，为电动汽车使用者提供账务管理、信息服务和客服支持等。</span
        >
        <p>3.12</p>
        <span
          >公共信息交换接口 EV charging and battery swap service business
          information interface<br />实现公共信息交换的接口，简称Icomm接口。</span
        >
        <p>3.13</p>
        <span
          >业务信息交换接口 EV charging and battery swap service common
          information interface <br />
          实现业务信息交换的接口，简称Iserv接口。</span
        >
        <p>3.14</p>
        <span
          >电动汽车充换电服务结算协议 Accounting  agreement<br />
          不同运营商进行结算业务规则与约定。简称结算协议。</span
        >
        <p>3.15</p>
        <span
          >电动汽车充换电服务结算平台 Clearing house<br />
          提供不同运营商之间结算业务的平台。简称结算平台。</span
        >
        <p>3.16</p>
        <span
          >信息交换功能实体  Function unit<br />
          在电动汽车充换电服务运营服务网络平台中，提供信息交换功能的功能单元，包括硬件基础设施和软件系统。</span
        >
        <p>3.17</p>
        <span
          >第三方服务及管理平台 Third-party services and management platform<br />
          与电动汽车充换电服务平台进行信息交换的独立运行平台，可以是以第三方的角色为客户提供系列的专业性服务的平台，也可以是政府管理监督信息服务平台等。</span
        >
        <p>3.18</p>
        <span
          >电动汽车运营服务平台 <br />
          对电动汽车运行过程信息进行采集、处理和运行管理的支撑系统，为联网用户提供信息服务。</span
        >

        <p>4.电动汽车充换电服务信息交换体系</p>
        <span
          >GB/T 19596、GB/T 29317、GB/Z
          19027-2005中确立的以及下列术语和定义适用于本文件。</span
        >

        <p>4.1</p>
        <span
          >参与电动汽车充换电服务的各业务角色和信息交换功能实体之间应在正常、安全、有效的原则下通过规范的接口进行信息交换，相互协同地向电动汽车用户提供充换电服务。<br />
          电动汽车充换电服务信息交换功能实体分层结构包括4层，分别是信息接入层、基础设施层、运营服务层和数据共享层。<br />
          电动汽车充换电服务信息交换接口既存在于各个服务逻辑层之间，也存在于同一逻辑层的不同平台之间。<br />
          电动汽车充换电服务信息交换接口如表1所示。</span
        >
        <img class="pc_img" src="@/assets/menthu/1/1.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/1/1.png" alt="" />
        <span
          >本标准规定Icomm和Iserv接口在《电动汽车充换电服务信息交换第2部分公共信息交换规范》、《电动汽车充换电服务信息交换第3部分业务信息交换规范》、《电动汽车充换电服务信息交换第4部分
          数据传输及安全》有详细定义。
          各个信息交换实体及其之间的信息交换接口的体系结构如图1所示。 </span
        >
        <img class="pc_img" src="@/assets/menthu/1/2.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/1/2.png" alt="" />
        <p>4.2　分层结构与能力</p>
        <small>4.2.1　分层结构</small>
        <small>4.2.2　信息接入层（EVAC Layer）</small>
        <span
          >由电动汽车用户以及各类信息终端组成。包括电动汽车、智能终端、智能卡、NFC等设备或模块，提供用户身份识别和用户终端服务交互功能。</span
        >
        <small>4.2.3　基础设施层（EVIE Layer）</small>
        <span
          >由交流充电桩、非车载充电机及其他充换电设备组成基础设施。基础设施连接到充换电运营服务平台，与信息接入层各类终端进行实时信息交互，完成向电动汽车输送电能量。</span
        >
        <small>4.2.4　运营服务层（EVSOP Layer）</small>
        <span
          >由充换电设施运营服务平台、电动汽车运营服务平台及结算平台，各平台通过相互协同构成运营服务网络，向用户提供完整的充换电服务。其中结算平台负责不同运营之间的结算服务。</span
        >
        <small>4.2.5　数据共享层（EVDSS Layer）</small>
        <span
          >由第三方服务或管理平台组成。可利用充换电设施运营服务网络提供的信息其信息统计、行业管理等功能。</span
        >
        <small>4.2.6　能力</small>
        <span
          >参与电动汽车充换电服务的实体通过本系列标准规定的接口进行信息交互，在一个运营商内部或者不同运营商之间共同完成充换电服务。电动汽车使用者可通过多种方式访问运营服务网络，包括电动汽车、智能终端、智能卡和NFC等途径获得身份识别认证和充电。电动汽车通过充电接口实现与运营服务网络的信息交换，智能终端通过二维码或蓝牙等技术实现与运营服务网络完成信息交换，智能卡通过基础设施刷卡识别与运营服务网络完成信息交换，NFC通过RFID终端与运营服务网络完成信息交换。<br />
          充换电运营服务平台应提供公共信息服务和业务服务功能。公共信息服务完成资源目录信息的交换，实现充电设施的发现与寻找等功能；业务服务完成充电过程信息的交换，实现充电认证和充电服务以及订单等功能。<br />
          电动汽车运营服务平台可提供电动汽车信息能力。<br />
          结算平台可实现不服务运营商之间的清分结算能力。<br />
          第三方服务及管理平台可扩展增值服务功能以及监督管理能力。</span
        >
        <p>4.3　接口</p>
        <small>4.3.1　Iac接口</small>
        <span
          >Iac接口定义电动汽车用户使用充换电服务的访问接口，是EVAC层与EVI层之间的接口。<br />
          信息交互功能指实现信息接入终端与运营服务网络之间的信息交互。
          <br />身份鉴别功能指电动汽车用户通过提供的不同的身份凭证被运营服务网络识别。<br />
          接口类型定义如表2所示。</span
        ><br />
        <img class="pc_img" src="@/assets/menthu/1/3.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/1/3.png" alt="" />
        <small>4.3.2　Icomm接口</small>
        <span
          >Icomm接口功能该接口定义归属不同运营商的充换电运营服务平台之间的公共信息交换接口。<br />
          资源信息服务指基本的资源信息发布、更新、同步等。<br />
          状态信息服务指基本的资源信息发布、更新、同步等。<br />
          统计信息服务指统计信息上报与发布。<br />
          本接口详细定义在《电动汽车充换电服务信息交换第2部分公共信息交换规范》中说明。</span
        >
        <small>4.3.3　Iserv接口</small>
        <span
          >Iserv接口功能该接口定义归属不同运营商的充换电运营服务平台之间的业务信息交换接口，主要功能如下：<br />
          平台认证服务指完成运营服务平台鉴权认证，获得平台之间数据访问和业务控制能力许可。<br />
          用户认证服务指完成归属不同运营商的电动汽车用户身份认证。<br />
          设备认证服务指完成归属不同充电运营商的设备认证。<br />
          业务策略服务指完成不同充换电运营服务平台服务策略的交换。例如设备定价方案等。<br />
          充电业务服务指完成不同充换电运营服务平台间充电过程的信息交换。<br />
          充电订单服务指完成不同充换电运营服务平台间充电交易记录的信息交换。<br />
          订单对账服务指完成不同充换电运营服务平台间对账和结算信息交换。<br />
          本接口详细定义在《电动汽车充换电服务信息交换
          第3部分业务信息交换规范》中说明。</span
        >
        <small>4.3.4　Ipay接口</small>
        <span
          >pay接口定义不同运营商与结算平台的业务信息交换接口。<br />
          待制定。</span
        >
        <small>4.3.5　Iev接口</small>
        <span
          >ev定义充换电运营服务平台与电动汽车运营服务平台的业务信息交换接口，实现车辆信息服务于充电信息服务的信息融合和协同功能。
          <br />待制定。</span
        >
        <small>4.3.6　Idev接口</small>
        <span
          >Idev定义充换电基础设施与充换电运营服务平台之间的信息交换接口。
          <br />待制定。</span
        >
        <small> 4.3.7　Iex接口</small>
        <span
          >Iex定义充换电运营服务平台与第三方服务及管理平台的扩展业务信息交换接口，在公共信息交换基础上，实现运营服务平台与不同第三方服务与管理平台的多应用信息交互扩展，原则参照行业平台的相关接口规范。
          待制定。</span
        >
        <p>5.电动汽车充换电服务信息交换服务流程</p>
        <small>5.1　业务角色定义</small>
        <span
          >为实现不同运营服务平台下的电动汽车充换电漫游等功能，各个运营服务平台之间应满足基本服务信息交换流程，流程中涉及的业务角色包括以下四类：<br />
          a)电动汽车基础设施 （EVI）<br />
          b)电动汽车使用者（EV Driver）<br />
          c)基础设施运营商（EVI Owner）<br />
          d)客户归属运营商（EV Driver Service Provider）</span
        >
        <small> 5.2　公共信息服务交换流程</small>
        <span
          >1）发布流程<br />
          充换电服务平台将所管理设备信息进行发布，提供电动汽车用户获得基础设施发现和查找功能。<br />
          2）查询流程<br />
          充换电服务平台将基础设施状态提供给其他充换电服务平台查询。<br />
          3）统计流程<br />
          充换电服务平台与将统计信息发布给第三方服务及管理平台。</span
        >
        <small>5.3　业务信息服务交换流程</small>
        <span
          >1）身份识别基本流程<br />
          电动汽车用户提供的用户凭证，在客户归属运营商平台获得身份认证，获得充电服务凭证。<br />
          2）充电启动与停止流程<br />
          电动汽车用户通过客户归属运营商平台，通知基础设施运营商平台启动与停止充电。<br />
          3）充电交易支付流程<br />
          充电结束后，基础设施运营商平台生成充电交易信息，提交客户归属运营商平台，由客户归属运营商平台，根据用户支付属性，完成充电交易支付，扣费成功后返回信息给基础设施运营商，并通知电动汽车使用者。<br />
          4）交易结算流程<br />
          基础设施运营商提交交易对账信息给客户归属运营商服务平台，双方进行信息数据核对，核对完成后按照双方约定的结算协议完成结算。</span
        >
        <p>6.电动汽车充换电服务信息交换功能</p>
        <small>6.1　公共信息交换</small>
        <small>6.1.1　一般要求</small>
        <span
          >公共信息是充电运营商服务平台之间，以及运营商服务平台向第三方服务及管理平台提供的电动汽车充换电服务的公共基础数据，如图7所示。</span
        >
        <small>6.1.2　功能</small>
        <small>6.1.3　平台认证服务</small>
        <span
          >应具备平台认证服务提供平台之间的鉴权认证功能。平台之间在信息交换前，需要完成平台认证，获得平台交换能力。</span
        >
        <small>6.1.4　基本信息服务（目录服务）</small>
        <span
          >应具备对外公开发布充电设施的基本信息功能，以便其他平台能够按照规定，在获得许可的情况下，发现并获得基本信息。</span
        >
        <small>6.1.5　统计信息服务</small>
        <span
          >应具备对外公开发布充电设施的统计信息功能，以便其他平台能够按照规定，在获得许可的情况下，发现并获得统计信息。</span
        >
        <small>6.1.6　传输机制</small>
        <span class="text_hh"
          >6.1.7　公共信息交换传输机制采用订阅发布模式，参与交换信息的平台一方作为信息发布方，另一方作为信息使用方，由信息提供方提供发布服务，信息使用方按照订阅模式获得信息。</span
        >
        <span class="text_hh"
          >6.1.8　公共信息交换传输机制工作模式同时满足push模式和pull模式。</span
        >
        <span class="text_hh"
          >6.1.9　平台认证服务提供平台之间的鉴权认证功能，支持分布式认证模式和中心交换认证模式，具体由《电动汽车充换电服务信息交换
          第4部分 数据传输及安全》规定。</span
        >
        <span class="text_hh"
          >6.1.10　公共信息交换功能内容涵盖交换功能、交换格式、发送频率、数据结构定义，由《电动汽车充换电服务信息交换
          第2部分 公共信息交换规范》规定。</span
        >
        <span class="text_hh"
          >6.1.11　公共信息交换的通信机制、通信协议、安全机制由本系列标准的《电动汽车充换电服务信息交换
          第4部分 数据传输及安全》规定。</span
        >
        <p>6.2　业务信息交换</p>
        <small>6.2.1　一般要求</small>
        <span
          >应具备对外公开发布充电设施的统计信息功能，以便其他平台能够按照规定，在获得许可的情况下，发现并获得统计信息。</span
        ><br />
        <img class="pc_img" src="@/assets/menthu/1/4.png" alt="" />
        <img class="mo_img" src="@/assets/mohu/1/4.png" alt="" />
        <small>6.2.2　功能</small>
        <small>6.2.3　平台认证</small>
        <span
          >应具备平台认证服务提供平台之间的鉴权认证功能。平台之间在信息交换前，需要完成平台认证，获得平台交换能力。</span
        >
        <small>6.2.4　用户认证</small>
        <span
          >应具备不同运营商前端设备分别能够识别不同运营商的客户身份，通过双方平台交互接口实现跨运营商的客户身份识别，验证身份的合法性及有效性，获得前端设备运营商的认证许可后，提供充电服务。</span
        >
        <small>6.2.5　设备认证</small>
        <span
          >可具备不同运营商通过双方平台交互接口实现跨运营商的设备识别，验证设备的合法性及有效性，获得设备运营商的认证许可后，提供充电服务。</span
        >
        <small>6.2.6　业务策略</small>
        <span
          >可具备面对不同运营商之间的客户，验证用户的服务套餐、余额、服务内容等。</span
        >
        <small>6.2.7　充电业务</small>
        <span
          >应具备不同运营商充电设备向客户提供充电启动，充电过程和充电停止功能。</span
        >
        <small>6.2.8　充电订单</small>
        <span
          >应具备设备归属运营商生成充电消费信息订单，并由客户归属运营商按照充电订单信息完成扣费，跨运营商的客户形成的充电消费订单由双方保留，形成对账机制。</span
        >
        <small>6.2.9　订单对账</small>
        <span
          >应具备运营商A与运营商B根据签署结算协议，按照充电订单信息以及结算服务协议完成结算流程。</span
        >
        <small>6.2.10　传输机制</small>
        <span class="text_hh"
          >6.2.11　业务信息交换传输机制采用请求-应答模式，参与交换信息的平台一方作为服务请求方，另一方作为服务应答方，由服务请求方向服务应答方提出服务请求，服务应答方按照规范提供服务执行并向请求方应答响应结果。</span
        >
        <span class="text_hh"
          >6.2.12　业务信息交换传输机制支持同步模式和异步模式，可由平台双方协商后确定具体模式。</span
        >
        <span class="text_hh"
          >6.2.13　平台认证服务提供平台之间的鉴权认证功能，支持分布式认证模式和中心交换认证模式，具体由《电动汽车充换电服务信息交换
          第2部分 公共信息交换规范》第4部分《数据传输及安全》规定。</span
        >
        <span class="text_hh"> 6.2.10　传输机制</span>
        <span class="text_hh"
          >6.2.11　业务信息交换传输机制采用请求-应答模式，参与交换信息的平台一方作为服务请求方，另一方作为服务应答方，由服务请求方向服务应答方提出服务请求，服务应答方按照规范提供服务执行并向请求方应答响应结果。</span
        >
        <span class="text_hh"
          >6.2.12　业务信息交换传输机制支持同步模式和异步模式，可由平台双方协商后确定具体模式。</span
        >
        <span class="text_hh"
          >6.2.13　平台认证服务提供平台之间的鉴权认证功能，支持分布式认证模式和中心交换认证模式，具体由《电动汽车充换电服务信息交换
          第2部分 公共信息交换规范》第4部分《数据传输及安全》规定。</span
        >
        <span class="text_hh"
          >6.2.14　业务信息交换功能内容涵盖交换功能、交换格式、发送频率、数据结构定义，由本系列标准的第《电动汽车充换电服务信息交换
          第3部分 业务信息交换规范》规定。</span
        >
        <span class="text_hh"
          >6.2.15　业务信息交换的通信机制、通信协议、安全机制由《电动汽车充换电服务信息交换
          第4部分 数据传输及安全》规定。</span
        >
        <p>7.电动汽车充换电服务信息交换安全机制</p>
        <small>7.1　通用要求</small>
        <span>
          &nbsp;&nbsp;
          &nbsp;电动汽车充换电服务信息交换应根据国家信息安全等级保护相关要求，针对各应用系统构建相应的安全保护等级。
          应根据系统的应用、数据、技术架构，将相同保护等级的信息系统适当集中，划分为不同的安全信息域，有区别地进行系统安全保护。<br />
          &nbsp;&nbsp;&nbsp;&nbsp;应对照不同等级信息安全保护要求，对现有安全防范措施进行评估，在综合利用现有技术和管理手段的基础上，有针对性的完善系统安全保护措施。<br />
             
          &nbsp;应从技术和管理两个方面，构建科学的信息安全保护体系。技术方面应从物理安全、网络安全、主机安全、应用安全、数据安全5个层面完善相应的保护措施。管理方面应从制度、机构、人员、建设、运维等5个层面完善相应的保护措施。  </span
        >
        <small>7.2　数据传输安全</small>
        <span>接口传输协议应采用加密技术，确保信息传输过程的安全性。</span>
        <small>7.3　角色身份认证</small>
        <span
          >接口应采用可信的平台接入授权机制，确保信息共享平台身份的真实性。</span
        >
        <small>7.4　信息隐私保护</small>
        <span
          >针对隐私性较高的信息，接口宜采用脱敏加密和密文空间计算技术，实现对隐私信息的保护。</span
        >
        <small>7.5　信息共享管理制度</small>
        <span
          >接口所采用的加密技术应建立相应的密钥、身份代码分配等资源信息管理制度，确保相关资源信息的有效分配与合理使用。</span
        >
        <small>7.6　密钥的使用及管理</small>
        <span
          >各运营商系统间在消息传递时，需要保障传输和接收数据的安全和完整。<br />
          具体处理流程规定参见《标准4 数据传输及安全》</span
        >
        <p>8.电动汽车充换电服务信息交换性能指标</p>
        <small>8.1　公共信息交换性能指标</small>
        <span
          >平台接口平均响应时间：不大于20秒。<br />
          数据正确率：应>99.99%。</span
        >
        <small>8.2　业务信息交换性能指标</small>
        <span
          >平台接口平均响应时间：不大于3秒。<br />
          数据正确率：应满足99.99%。</span
        >
        <p>附　录　A二维码规范</p>

        <span
          >使用URI（Uniform Resource
          Identifier，是一个用于标示某一互联网资源名称的字符串，该种标示允许用户对任何资源通过特定的协议进行交互操作）的进行编码。<br />
          格式如下：<br />
          hlht://充电设备接口ID.运营商ID/[自定义]</span
        >
      </div>
    </div>
  </div>
</template>


<script>
import Menthu from "@/components/menthu";
export default {
  components: {
    Menthu,
  },
};
</script>

<style scoped>
.home_con {
  display: flex;
  text-align: left;
 
}
small {
  font-family: Helvetica;
  margin-top: 24px;
}
.mentCon{
   margin-top:40px;
}
.mentCon .text_hh {
  margin-top: 12px;
  display: flex;
  font-size: 12px;
  font-family: Helvetica;
  color: #191c27;
  line-height: 18px;
}
.mentCon .mo_img {
  display: none;
}
@media screen and (max-width: 768px) {
  .moment {
    margin: 0px 15px 0px 15px;
    display: none;
  }
  .mentCon {
    width: 100%;
    margin: 0px 15px 32px 15px;
  }

  .mentCon .ment_title {
    width: 100%;
    height: 74px;
    font-size: 17px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 500;
    color: #191c27;
   
    border-bottom: 1px solid #e5e5e5;
  }
  .mentCon p {
    width: 92%;
    margin: 24px 0px 16px 0px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #191c27;
    line-height: 24px;
  }
  .mentCon small {
    margin-bottom: 12px;
    display: block;
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #191c27;
    line-height: 21px;
  }
  .mentCon span {
    font-size: 14px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #5a6073;
    line-height: 20px;
  }
  .mentCon .pc_img {
    display: none;
  }
  .mentCon .mo_img {
    display: block;
  }
}
</style>


// WEBPACK FOOTER //
// src/page/document/documenth.vue